<div class="folder-header">
  <div class="headline-large" *ngIf="!parentFolderID">{{ parentTitle }}</div>

  <div class="folder-breadcrumbs" *ngIf="parentFolderID">
    <ng-container *ngIf="folderData?.parentID">
      <div class="body-link text-align breadcrumbs-dots" (click)="clickDropdownTrigger($event)">...</div>
      <div class="dropdown-list" *ngIf="showDropDown">
        <ul class="list-body">
          <li
            *ngFor="let item of dropDownData"
            (click)="onDropdownItemClick(item)"
            class="dropdown-item"
          >
            <img alt="" class="folder-icon" src="assets/icons/folder2.svg">
            <img alt="verified" *ngIf="item?.attributes?.document_review === 1" class="folder-icon folder-check" src="assets/icons/check.svg">
            <span class="folder-title">{{ item.title }}</span>
          </li>
        </ul>
      </div>
      <div class="divider">/</div>
    </ng-container>
    <div (click)="backNavigation()" class="body-link text-align"><img class="folder-check" *ngIf="parentFolderData?.attributes?.document_review === 1" src="assets/icons/check.svg">{{ parentTitle }}</div>
    <div class="divider">/</div>
    <div class="headline-medium"><img class="folder-check" *ngIf="folderData?.attributes?.document_review === 1" src="assets/icons/check.svg">{{ folderData | translateBy: 'title' }}</div>
    <button [class.disabled]="!canEdit" class="folder-edit-button" (click)="editFolder()">
      {{ "SHARED.Edit" | translate }}
    </button>
  </div>

  <div class="filter" *ngIf="filter?.config">
    <ion-button (click)="filtersComponent.open()" class="page-button" color="light">{{"SHARED.Add_Filters" | translate}}</ion-button>
    <app-active-filters #filtersComponent (onSelect)="onFilterChange($event)" [config]="filter?.config"></app-active-filters>
  </div>

  <app-copy-link class="copy-link" *ngIf="allowCopy && parentFolderID" [config]="copyConfig"></app-copy-link>
</div>
